import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetBrands = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/brands/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load brands.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateBrand = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/brands/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create brand.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateBrand = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/brands/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update brand.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteBrand = async (id: number): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/brands/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete brand.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
